import * as React from "react";
import {InputFieldState} from "./InputFieldState";

interface ListProps {
    label: string;
    state: InputFieldState
    onChange?: (value: string) => void;
    errorMessage?: string,
    editable?: boolean,
    darkMode?: boolean,
    type?: string,
    unit?: string,
}

interface ListEntry {
    value: string
}

interface ListState {
    entries: ListEntry[],
}

/**
 * Text Input Element
 */
export class List extends React.Component<ListProps, ListState> {

    public static defaultProps = {
        label: "Label",
        darkMode: false,
        type: "text",
    };

    state: ListState = {
        entries: [
            {value: ''},
        ],
    }

    type: any = this.props.type;

    componentDidUpdate(prevProps: ListProps) {
        if (this.props.state.value !== prevProps.state.value) {
            if (typeof this.props.state.value === "string") {
                this.setState({entries: JSON.parse(this.props.state.value)})
            }
        }
    }

    addElement(below: ListEntry) {
        let entries = this.state.entries;
        entries.splice(this.state.entries.indexOf(below) + 1, 0, {value: ''})
        this.setState({entries: entries});
    }

    removeElement(element: ListEntry) {
        let entries = this.state.entries;
        entries.splice(this.state.entries.indexOf(element), 1)
        this.setState({entries: entries});
    }

    setValue(entry: ListEntry, value: string) {
        let entries = this.state.entries;
        const index = this.state.entries.indexOf(entry);
        entries[index].value = value;
        this.setState({entries: entries}, () => {
            this.props.onChange(JSON.stringify(entries));
        });
    }

    render() {

        let classNameLabel = this.props.darkMode ? 'label dark-mode-label' : 'label';
        let classNameInput = 'react-list-input';

        return <label className={classNameLabel}>
            <div className="labelText">{this.props.label}</div>

            {this.state.entries.map((entry) => {
                return <div style={{display: 'flex', marginBottom: '2px'}}>
                    <input style={{flexGrow: 10}} readOnly={this.props.editable === false} autoComplete="none"
                           onChange={(event) => this.setValue(entry, event.target.value)} value={entry.value}
                           type={this.type} className={classNameInput}/>
                    <button onClick={() => this.addElement(entry)} style={{flexGrow: 1, minWidth: '50px'}}
                            className={"react-list-plus"}>+
                    </button>
                    {this.state.entries.length > 1 &&
                        <button onClick={() => this.removeElement(entry)} style={{flexGrow: 1, minWidth: '50px'}}
                                className={"react-list-minus"}>-</button>
                    }
                </div>
            })
            }

            <div className="error_message">{this.props.state.errorMessage}</div>
        </label>
    }
}